import { TimeslotOrderGroupModel } from '@merchant-clients/order';

export const INITIAL_EXPANDED_TIMESLOT_COUNT = 2;

export type TimeslotGroupKeySource = Pick<
  TimeslotOrderGroupModel,
  'timeSlotStart' | 'timeText' | 'timeTextEnd'
>;

export function getTimeslotGroupKey(group: TimeslotGroupKeySource): string {
  return `${group.timeSlotStart ?? group.timeText}-${group.timeTextEnd}`;
}

export function isTimeslotGroupInitiallyExpanded(index: number): boolean {
  return index < INITIAL_EXPANDED_TIMESLOT_COUNT;
}

/**
 * Only current groups are kept. Known groups keep their previous expanded
 * state; new groups default from position (the first two start expanded).
 */
export function resolveTimeslotExpandedState(
  groups: TimeslotGroupKeySource[],
  previous: Record<string, boolean>,
): Record<string, boolean> {
  return Object.fromEntries(
    groups.map((group, index) => {
      const key = getTimeslotGroupKey(group);
      return [key, previous[key] ?? isTimeslotGroupInitiallyExpanded(index)];
    }),
  );
}
